<template>
  <div class="p-1 border border-slate-300 bg-gray-100 opacity-50 rounded-[5px]">
    <div class="pb-2 border-b mb-2 font-semibold text-green-800 px-3">Debug Code</div>
    <pre>
<slot />
    </pre>
  </div>
</template>
